export const RATING_STARS = [5, 4, 3, 2, 1] as const;
export const TREEMAP_MAX_ITEMS = 28;
export const GREEN_SCALE = ['#17B055', '#4BD784', '#BCE8CE', '#D3EFDF', '#ECFFF9'] as const;
export const RED_SCALE = ['#F44921', '#FA7657', '#FFD8CF', '#FFE7E1', '#FFF2EC'] as const;
export const YELLOW_SCALE = ['#F4A621', '#FABE57', '#FFEDCF', '#FFF4E1', '#FFF9EC'] as const;
export const BLUE_SCALE = ['#2255A1', '#5587D0', '#BCCCE3', '#D3DDEC', '#EEF2FF'] as const;
